import Icon from '../components/Icon.vue'

Icon.register({"signal":{"width":640,"height":512,"paths":[{"d":"M36 384H92C98.6 384 104 389.4 104 396V500C104 506.6 98.6 512 92 512H36C29.4 512 24 506.6 24 500V396C24 389.4 29.4 384 36 384zM152 348V500C152 506.6 157.4 512 164 512H220C226.6 512 232 506.6 232 500V348C232 341.4 226.6 336 220 336H164C157.4 336 152 341.4 152 348zM280 268V500C280 506.6 285.4 512 292 512H348C354.6 512 360 506.6 360 500V268C360 261.4 354.6 256 348 256H292C285.4 256 280 261.4 280 268zM408 156V500C408 506.6 413.4 512 420 512H476C482.6 512 488 506.6 488 500V156C488 149.4 482.6 144 476 144H420C413.4 144 408 149.4 408 156zM536 12V500C536 506.6 541.4 512 548 512H604C610.6 512 616 506.6 616 500V12C616 5.4 610.6 0 604 0H548C541.4 0 536 5.4 536 12z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/signal.js
// module id = null
// module chunks = 